import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs';

@Injectable()
export class ExternalViewService {

    constructor(private http: HttpClientService) {}

    getViewUrl(origin, idApplication, idMenu): Observable<string> {
        return this.http.get(`${origin}/permissions/menu/${idApplication}/${idMenu}`)
    } 
    
}


// WEBPACK FOOTER //
// ./src/app/services/external-view/external-view.service.ts